import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'

export async function generatePdfFromHtml(
  html,
  margin,
  width,
  filename = 'document.pdf'
) {
  // create container div and its content
  const divEl = document.createElement('div')
  divEl.id = 'rollover-pdf'
  divEl.innerHTML = html

  // Remove adel material symbols
  divEl.querySelectorAll('.adel-material-symbols').forEach(el => el.remove())
  divEl.querySelectorAll('dfn').forEach(el => el.replaceWith(...el.childNodes))

  const style = document.createElement('style')
  style.textContent = `
    #rollover-pdf {
      width: 800px;
      transform-origin: top left;
      transform: scale(0.98);
      margin: 20 0 20 20;
      em {
        font-style: normal
      }
    }
  `
  document.head.appendChild(style)
  document.body.appendChild(divEl)

  let pdf = new jsPDF('p', 'pt', 'a4', true)
  return new Promise((resolve, reject) => {
    pdf.html(divEl, {
      margin,
      width,
      windowWidth: 800,
      x: 10,
      y: 10,
      autoPaging: 'text',
      callback: function (pdfInstance) {
        try {
          // Get all links and its container dimensions
          const links = divEl.querySelectorAll('a')
          const containerRect = divEl.getBoundingClientRect()

          const pdfWidth = pdfInstance.internal.pageSize.getWidth()
          const pdfHeight = pdfInstance.internal.pageSize.getHeight()

          // margins inside PDF
          const marginLeftPt = 20
          const marginTopPt = 20

          // scaling factor between html and pdf
          const containerWidthPx = divEl.scrollWidth
          const pdfContentWidth = pdfWidth - marginLeftPt * 2
          const scaleX = pdfContentWidth / containerWidthPx

          const offsetXpx = 0
          const offsetYpx = 10

          // Add clickable link overlays for al <a> elements
          links.forEach(link => {
            const clientRects = link.getClientRects()
            for (let rect of clientRects) {
              // relative positions inside container
              let relX = rect.left - containerRect.left + offsetXpx
              let relY = rect.top - containerRect.top + offsetYpx
              let pdfX = marginLeftPt + relX * scaleX
              let pdfY = marginTopPt + relY * scaleX
              let pdfW = rect.width * scaleX
              let pdfH = rect.height * scaleX
              // Calculate PDF page number for this rect
              const pageNum = Math.floor(pdfY / pdfHeight)
              pdfY = pdfY - pageNum * pdfHeight
              pdfInstance.setPage(pageNum + 1)
              // Add clickable link
              pdfInstance.link(pdfX, pdfY, pdfW, pdfH, { url: link.href })
            }
          })
          setTimeout(() => {
            const totalPages = pdfInstance.getNumberOfPages()
            const lastPage = pdfInstance.internal.pages[totalPages]
            if (!lastPage || lastPage.length <= 1) {
              pdfInstance.deletePage(totalPages)
            }
            pdfInstance.save(filename)
            resolve()
          }, 0)
        } catch {
          console.error('PDF generation failed')
        } finally {
          document.body.removeChild(divEl)
          document.head.removeChild(style)
        }
      }
    })
  })
}
